import { DiscountType } from "src/types/discountTypes";
import { Box, Divider } from "@mui/material";
import StarRateIcon from "@mui/icons-material/StarRate";
import ShareButton from "../ShareButton";
import Image from "next/legacy/image";
import GetDiscountCard from "./GetDiscountCard";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import theme from "src/styles/theme";
import Carousel from "react-material-ui-carousel";
import { useState } from "react";
import HaveQuestions from "../HaveQuestions";

function CarouselItem({ image, alt }: { image: string; alt: string }) {
  return (
    <Box
      sx={{
        width: "100%",
        height: 300,
        position: "relative",
        overflow: "hidden",
      }}
      borderRadius={4}
    >
      <Image
        alt="project image"
        src={image}
        sizes="(min-width: 100vw) 100vw,
                 100vw"
        layout="fill"
        objectFit="cover"
        quality={100}
      />
    </Box>
  );
}

export default function SmallDiscountContent({
  discount,
  shareLinkObject,
  loading,
  localeStrings,
  buttonText,
  timeLeftString,
  handleSendCodes,
  smAndDown,
  canGetCodes,
}: {
  discount: DiscountType & { numCouponsFromDb: number };
  shareLinkObject: any;
  loading: any;
  localeStrings: any;
  buttonText: string;
  timeLeftString: string;
  handleSendCodes: any;
  smAndDown?: boolean;
  canGetCodes: boolean;
}) {
  const [carouselIndex, setCarouselIndex] = useState(0);

  return (
    <>
      <h1 className="text-text headline-2">{discount.shortName}</h1>
      <div className="flex align-items-center justify-content-space-between">
        <div className="d-grid align-items-center">
          <a
            href={discount.domain}
            target="_blank"
            rel="noreferrer"
            className="text-text pointer subtitle-4 fw-700"
            style={{ textDecoration: "none" }}
            children={discount.compName}
          />
          <div className="flex align-items-center">
            {/* @ts-ignore*/}
            <StarRateIcon color="textColors" />
            <p className="text-text subtitle-4">{discount.googleRating}</p>
          </div>
        </div>

        <div className="flex gap-large">
          <ShareButton linkObj={shareLinkObject} smAndDown={smAndDown} />
          <div className="flex gap-normal">
            <Image
              src="/assets/heart-plus.svg"
              width="20"
              height="20"
              alt="save-icon"
            />
          </div>
        </div>
      </div>
      <Box
        sx={{
          width: "100%",
          minHeight: "100%",
          position: "relative",
        }}
      >
        <Carousel
          index={carouselIndex}
          autoPlay={false}
          sx={{
            borderRadius: 4,
            minHeight: 300,
            position: "relative",
          }}
          navButtonsAlwaysVisible={true}
          swipe={true}
          navButtonsProps={{
            style: {
              // @ts-ignore
              backgroundColor: theme.palette.paper,
              // @ts-ignore
              color: theme.palette.textColors.main,
              boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.25)",
            },
          }}
          navButtonsWrapperProps={{
            // Move the buttons to the bottom. Unsetting top here to override default style.
            style: {
              bottom: "unset",
              top: "0",
              height: 300,
            },
          }}
          indicatorContainerProps={{
            style: {
              margin: "0",
              position: "absolute",
              bottom: "22px",
              zIndex: 10,
            },
          }}
          indicatorIconButtonProps={{
            style: {
              color: "#ffffff",
            },
          }}
          activeIndicatorIconButtonProps={{
            style: {
              backgroundColor: "#ffffff",
              color: "#ffffff",
            },
          }}
        >
          {discount?.images?.map((item, i) => (
            <CarouselItem key={i} image={item.url} alt={item.alt} />
          ))}
        </Carousel>
      </Box>
      <div className="flex align-items-center justify-content-space-between gap-normal mt-large">
        <div className="d-grid gap-large">
          <h2 className="headline-4">{discount.subtitle1}</h2>
          <h3 className="text-text body-3">{discount.subtitle2}</h3>
        </div>
        <div className="card-icon-big discount-item__discount">
          <p className="body-3 white">{discount.discount}%</p>
        </div>
      </div>
      <Divider></Divider>
      <GetDiscountCard
        buttonText={buttonText}
        emailLink={localeStrings.discountPage.emailLink}
        remainingAmount={discount.numCouponsFromDb}
        couponsLeft={localeStrings.discountPage.couponsLeft}
        timeLeftString={timeLeftString}
        clickHandler={() => handleSendCodes().catch((e: any) => {})}
        loading={loading}
        offerIsAvailable={localeStrings.discountPage.theOfferIsAvailable}
        canGetCodes={canGetCodes}
        isMobile
      />
      <div className="flex align-items-center justify-content-center">
        <HaveQuestions
          email={`mailto:${localeStrings?.errorPage?.mailToLink}`}
        />
      </div>
      <Divider></Divider>
      <h3 className="text-text fw-600">
        {localeStrings.discountPage.description}
      </h3>
      <div className="text-text body-1">{discount.description}</div>
      <Divider></Divider>
      <h3 className="text-text fw-600">
        {localeStrings.discountPage.howToUse}
      </h3>
      <div className="text-text body-1">{discount.application}</div>
      <div className="flex align-items-center">
        <a
          href={discount.accessUrl}
          target="_blank"
          className="text-text pointer subtitle-4 underline-link"
          rel="noreferrer"
        >
          <div className="flex gap-normal">
            {/* @ts-ignore*/}
            <OpenInNewIcon color="textColors" />
            <div>{localeStrings.discountPage.moreInformation}</div>
          </div>
        </a>
      </div>
    </>
  );
}
